import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import SarasPopup from '../../../library/container/popup/SarasPopup'

const HoldStatus = (props) => {
    const { formObject, viewData, className } = props;
    const [open, setOpen] = React.useState(false);
    const targetRef = React.useRef();

    const handleClose = () => {
        setOpen(false);
    };

    const showDetails = () => {
        setOpen(true);
    };

    const renderDetails = () => {
        return(
            <SarasPopup anchorRef={targetRef} open={open} onClose={handleClose}>
                <ul className="uiPadding10">
                    <li>
                        <span className='uiBold'>
                            <FormLabel formObject={formObject}  rowKey="" action={{ paramName: "holdDate" }} value="Since" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "holdDate" }} className=' uiDisplayInline' />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "holdDays" }} className='uiBold uiDisplayInline uiSpacerL5' />
                    </li>
                    <li>
                        <span className='uiBold' style={{verticalAlign: "top"}}>
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reason" }} value="For" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reason" }} className=' uiDisplayInline' />
                    </li>
                </ul>
            </SarasPopup>
        )
    }

    if (!viewData)
        return null

    //uiSpacerL10
    return (
        <div ref={targetRef} className={`uiInline ${className}`} 
            onMouseOver={showDetails} onMouseOut={handleClose}>
            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "status" }} className='uiBold' />
            {renderDetails()}
        </div>
    )
}

export default withView(HoldStatus, "projectHold", "projectHold")